import React, { useState } from "react"
import Icon from "../../icon/icon.component.jsx"
import QuoteService from "../../../state/quote/QuoteService"
import { FormattedMessage, defineMessages } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"
import FormattedInputField from "../../../sharedComponents/formattedInputField.component"
import GlobalHelper from "../../GlobalHelper"
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context"
import { InvoiceService } from "../../../state/invoice/services"
import OrderService from "../../../state/order/OrderService"
import PriceListService from "../../../state/price-list/PriceListService"
import { DISCOUNT_TYPE } from "../../../state/pricing/DiscountType"
import { QUOTE } from "../../../state/quote/Constants"
import { INVOICE } from "../../../state/invoice/Constants"
import { ORDER } from "../../../state/order/Constants"
import { PRICE_LIST } from "../../../state/price-list/Constants"
import { PRICING_TABLE } from "../../../utils/pricing/constants"
import PricingTableRowService from "../../../state/pricing/PricingTableRowService"
 

type OwnProps = {
    objectId: string,
    itemIdList: Set<string>,
    currency: string,
    type: string,
    onChange: () => void,
    editable: boolean,
    title: string,
}

const messages = defineMessages({
    "bulk_save_type_error": {
        id: "quote.items.bulk_save_type_error",
        defaultMessage: "\"Invalid object type. Cannot save.\"",
    },
})

const ItemBulkDiscountComponent = (props: OwnProps & IntlProps) => {

    const [state, setState] = useState({
        editMode: false,
        saveSuccess: false,
        discountValue: "0",
        discountType: DISCOUNT_TYPE.DISCOUNT_PERCENT_BEFORE_TAXES,
    })

    const selectOptions = {
        [DISCOUNT_TYPE.DISCOUNT_PERCENT_BEFORE_TAXES]: "%",
        [DISCOUNT_TYPE.DISCOUNT_CURRENCY_VALUE]: props.currency,
    }

    const [errorMsg, setErrorMsg] = useState<string>("")

    const triggerEdit = (event) => {
        event?.preventDefault()
        setState({
            ...state, editMode: !state.editMode
        })
    }

    const handleFocus = (event) => {
        event.target.select()
    }

    const save = (event, type: string, value: string) => {
        event.preventDefault()
        setErrorMsg("")

        if (parseFloat(value) === 0) {
            type = "none"
        }

        const payload = {
            discountType: type,
            discountValue: value,
            rowIds: Array.from(props.itemIdList.values()),
            ...(props.type == PRICING_TABLE? {updateType : "discount"} : {})
        }

        let res
        switch (props.type) {
        case QUOTE:
            res = QuoteService.applyBulkDiscount(props.objectId, payload)
            break
        case INVOICE:
            res = InvoiceService.applyBulkDiscount(props.objectId, payload)
            break
        case ORDER:
            res = OrderService.applyBulkDiscount(props.objectId, payload)
            break
        case PRICE_LIST:
            res = PriceListService.applyBulkDiscount(props.objectId, payload)
            break
        case PRICING_TABLE:
            res = PricingTableRowService.applyBulkUpdate(props.objectId, payload)
            break
        default:
            setErrorMsg(props.intl.formatMessage(messages["bulk_save_type_error"]))
            return
        }

        res.then((r) => {
            if (!r.error) {
                setState({
                    ...state, saveSuccess: true
                })
                setTimeout(() => {
                    setState({
                        ...state,
                        editMode: false,
                        saveSuccess: false,
                        discountType: type,
                        discountValue: "0",
                    })
                    props.onChange()
                }, 1000)
            } else {
                setErrorMsg(r.error.message)
            }
        })
    }

    return (
        <span>
            <button title={props.title} type="button" className="btn btn-sm btn-outline-primary"
                aria-expanded="false" onClick={triggerEdit} disabled={!props.editable}>
                <FormattedMessage
                    id="common.quote.item.discount.add_discount_btn"
                    defaultMessage="Discount" />
            </button>
            <div className={"dropdown-menu p-4 " + (state.editMode ? "show" : "")} style={{ top: "auto" }}>
                <p className="m-0">
                    <FormattedInputField
                        type="text"
                        className="form-control"
                        aria-label={"Discount value"}
                        placeholder={GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())}
                        onFocus={handleFocus}
                        valueType="decimal"
                        value={state.discountValue}
                        onValueChange={(newValue) => {
                            let discountType = state.discountType
                            if (!discountType || discountType === DISCOUNT_TYPE.DISCOUNT_NONE) {
                                discountType = DISCOUNT_TYPE.DISCOUNT_PERCENT_BEFORE_TAXES
                            }
                            setState({ ...state, discountValue: newValue, discountType: discountType })
                        }}
                    />
                </p>
                <p className="m-0 pt-2">
                    <select value={state.discountType}
                        className="custom-select"
                        onChange={(event) => {
                            setState({ ...state, discountType: event.target.value })
                        }}
                    >
                        {Object.entries(selectOptions).map(([key, value]) => <option key={key} id={key}
                            value={key}>{value}</option>)}
                    </select>
                </p>
                <div className="text-danger">{errorMsg}</div>
                <p className="m-0 pt-2">
                    <button title={"Cancel discount"} className="btn btn-sm btn-outline-secondary"
                        onClick={triggerEdit}>
                        <Icon value={"arrow-left"} />
                    </button>
                    {!state.saveSuccess ?
                        <button title={"Save discount"} className="btn btn-sm btn-outline-primary ml-2"
                            onClick={(e) => save(e, state.discountType, state.discountValue)}>
                            <Icon value={"save"} />
                        </button>
                        :
                        <button className="btn btn-sm ml-2 shadow-none" disabled>
                            <Icon value={"check"} className={"text-success short-fade-out"} />
                        </button>
                    }
                </p>
            </div>
        </span>
    )
}

export default ItemBulkDiscountComponent


// WEBPACK FOOTER //
// ./src/common/quote/component/ItemBulkDiscountComponent.tsx